import React, { useRef, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Button,
  Box,
  CircularProgress,
  Typography
} from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import "./PartnerList.css";

const PartnerListComponent = ({
  partners,
  searchValue,
  setSearchValue,
  onBlock,
  onUnblock,
  onSelectPartner,
  selectedPartnerId,
  onLoadMore,
  hasMore,
  loading,
  onGoBack
}) => {
  const navigate = useNavigate();
  const scrollContainerRef = useRef(null);

  const handleProceed = (id) => {
    navigate(`/home/configuration/partner/bills/summery/${id}`);
  };

  return (
    <div className="payoutpartner-layout">
      <Sidebar />
      <div className="payoutpartner-list-container">
        <div className="payoutpartner-list-header">
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-around" }}>
            <button
              className="payoutpartner-back-button"
              onClick={onGoBack}
              aria-label="Go back"
            >
              ←
            </button>
            <h1 className="payoutpartner-title">Partners </h1>
          </div>

          <div className="payoutpartner-actions-wrapper">
            <div className="payoutpartner-search-container">
              <TextField
                label="Search by Owner ID / Cohort ID"
                variant="outlined"
                size="small"
                fullWidth
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </div>
            <Box className="payoutpartner-action-buttons">
              <Button
                onClick={onBlock}
                className="payoutpartner-block-button"
                variant="outlined"
              >
                Block Payout
              </Button>
              <Button
                onClick={onUnblock}
                className="payoutpartner-unblock-button"
                variant="outlined"
              >
                Unblock Payout
              </Button>
            </Box>
          </div>
        </div>

        <TableContainer
          component={Paper}
          className="payoutpartner-table-container"
          ref={scrollContainerRef}
        >
          <Table stickyHeader className="payoutpartner-table">
            <TableHead>
              <TableRow>
                <TableCell className="payoutpartner-table-header-cell">ID</TableCell>
                <TableCell className="payoutpartner-table-header-cell">Name</TableCell>
                <TableCell className="payoutpartner-table-header-cell">Description</TableCell>
                <TableCell className="payoutpartner-table-header-cell">Type</TableCell>
                <TableCell className="payoutpartner-table-header-cell">Cohort ID</TableCell>
                <TableCell className="payoutpartner-table-header-cell">Owner ID</TableCell>
                <TableCell className="payoutpartner-table-header-cell">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {partners.length > 0 ? (
                partners.map((partner) => (
                  <TableRow
                    key={partner.id}
                    className={`payoutpartner-row ${selectedPartnerId === partner.id ? 'payoutpartner-row-selected' : ''}`}
                    onClick={() => onSelectPartner(partner.id)}
                  >
                    <TableCell>{partner.id}</TableCell>
                    <TableCell>{partner.name}</TableCell>
                    <TableCell>{partner.description}</TableCell>
                    <TableCell>{partner.type}</TableCell>
                    <TableCell>{partner.cohortId}</TableCell>
                    <TableCell>{partner.ownerId}</TableCell>
                    <TableCell>
                      <IconButton
                        className="payoutpartner-view-icon"
                        size="small"
                        onClick={() => handleProceed(partner.id)}
                      >
                        <VisibilityIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                // Show "Partner not found" message when search yields no results
                <TableRow>
                  <TableCell colSpan={7} align="center" className="payoutpartner-not-found-cell">
                    <SearchOffIcon className="payoutpartner-not-found-icon" />
                    <Typography variant="h6" className="payoutpartner-not-found-text">
                      Partner not found
                    </Typography>
                    <Typography variant="body2" className="payoutpartner-not-found-subtext">
                      {searchValue.trim() 
                        ? `No partners found for "${searchValue}"` 
                        : "No partners available"}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          
          {/* Load More Section - Only show if we have partners */}
          {partners.length > 0 && (
            <div className="payoutpartner-load-more-container">
              {hasMore ? (
                <Button
                  onClick={onLoadMore}
                  disabled={loading}
                  className="payoutpartner-load-more-button"
                  variant="contained"
                >
                  {loading ? (
                    <>
                      <CircularProgress size={20} style={{ marginRight: "10px" }} />
                      Loading...
                    </>
                  ) : (
                    "Load More"
                  )}
                </Button>
              ) : (
                <div className="payoutpartner-no-more-cell">
                  No more partners to load
                </div>
              )}
            </div>
          )}
          
          {/* Show loading only when initial load and no partners yet */}
          {loading && partners.length === 0 && !searchValue && (
            <TableRow>
              <TableCell colSpan={7} align="center" className="payoutpartner-loading-cell">
                <CircularProgress size={30} />
                <Typography variant="body1" style={{ marginTop: "10px" }}>
                  Loading partners...
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableContainer>
      </div>
    </div>
  );
};

export default PartnerListComponent;